import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { lighten } from '@mui/system';
import sortBy from 'lodash/sortBy';
import React, { FC, useMemo } from 'react';

import { getColorFromIndex } from '../../utils';
import { SemicontrolledInput } from '../SemicontrolledInput';

import type { HandleChangeSlotFn, LabwareSlotData } from '.';

export interface LabwareRow {
  colorIndex: number;
  labwareId: string;
  loadOrder: number;
  nickname: string;
  slot: number;
  unloadOrder: number;
}

export const LabwareLoadingTable: FC<{
  handleChangeSlot: HandleChangeSlotFn;
  labwareSlotData: LabwareSlotData;
}> = (props) => {
  const { handleChangeSlot, labwareSlotData } = props;

  const sortedRows = useMemo<LabwareRow[]>(() => {
    return sortBy(labwareSlotData, ({ data }) => data.labwareName).map(
      ({ slot, data: { id, labwareName, colorIndex } }): LabwareRow => ({
        labwareId: id,
        loadOrder: 42,
        unloadOrder: 42,
        colorIndex,
        slot,
        nickname: labwareName,
      })
    );
  }, [labwareSlotData]);

  return (
    <TableContainer>
      <Table aria-label="Labware layout table">
        <TableHead>
          <TableRow>
            <TableCell>Labware</TableCell>
            <TableCell>Slot</TableCell>
            {/* NOTE(IL, 2024-04-05): Load/Unload order hidden for user test 1 */}
            {/* <TableCell>Load Order</TableCell> */}
            {/* <TableCell>Unload Order</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map(
            (
              {
                labwareId,
                nickname,
                colorIndex,
                slot,
                // loadOrder,
                // unloadOrder,
              },
              index
            ) => (
              <TableRow key={index}>
                <TableCell>
                  <Box
                    sx={{
                      backgroundColor: lighten(
                        getColorFromIndex(colorIndex),
                        0.66
                      ),
                      borderRadius: '3px',
                      padding: '0.5rem',
                    }}
                  >
                    {nickname}
                  </Box>
                </TableCell>
                <TableCell>
                  <SemicontrolledInput
                    value={`${slot}`}
                    handleSaveValue={(newSlot) => {
                      const n = Number.parseInt(newSlot);
                      if (Number.isFinite(n)) {
                        handleChangeSlot(labwareId, n);
                      }
                    }}
                  />
                </TableCell>
                {/* <TableCell sx={{ fontWeight: 'semibold', color: 'grey.600' }}>
                  {loadOrder}
                </TableCell>
                <TableCell sx={{ fontWeight: 'semibold', color: 'grey.600' }}>
                  {unloadOrder}
                </TableCell> */}
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
